import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var NumberOfSubmission = /*#__PURE__*/function () {
  function NumberOfSubmission() {
    _classCallCheck(this, NumberOfSubmission);
  }

  _createClass(NumberOfSubmission, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value >= this.minTime;
    }
  }]);

  return NumberOfSubmission;
}();

_defineProperty(NumberOfSubmission, "minTime", 1);

_defineProperty(NumberOfSubmission, "unlimited", -1000);